function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .celebrities-cls-1{fill:#fff}.celebrities-cls-2{fill:#07b6b6}.celebrities-cls-3{fill:#21a7aa}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_227",
  d: "M9.8 32.7l24.071 29.9H35.1l24.07-29.9-.675-1.719-9.273-10.135-1.043-.246H20.423l-1.105.737-9.457 10.316z",
  className: "celebrities-cls-1",
  "data-name": "Path 227",
  transform: "translate(-9.623 -20.6)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_228",
  d: "M9.689 32.7l2.088 2.579a.835.835 0 0 0 1.351-.983l-.061-.061-1.658-2.026 8.72-9.457 5.281 8.6H14.478a.878.878 0 0 0-.86.86.827.827 0 0 0 .86.8h11.79l2.088 8.474a.848.848 0 0 0 .8.614h.184a.827.827 0 0 0 .614-.982L27.988 33h12.833l-2.026 8.11a.8.8 0 0 0 .614.982h.184a.8.8 0 0 0 .8-.614L42.479 33h14.185L36.093 58.549l3.5-13.694a.819.819 0 1 0-1.6-.368l-3.619 14.185-3.623-14.246a.819.819 0 1 0-1.6.368l3.5 13.755-15.413-19.1a.854.854 0 0 0-1.167 0 .845.845 0 0 0-.123 1.044L33.76 62.6l.123.123v.061c.061.061.123.061.184.123h.491l.061-.061.061-.061.061-.061.246-.123.061-.061L59.059 32.7c.061-.061.061-.061.061-.123v-.061a.46.46 0 0 0 .061-.307v-.061a.464.464 0 0 0-.061-.246v-.061c-.061-.061-.061-.123-.123-.184l-9.886-10.811c-.061-.061-.123-.123-.184-.123a1.138 1.138 0 0 0-.43-.123H20.312a.887.887 0 0 0-.43.123c-.061.061-.123.123-.184.123L9.75 31.653a.764.764 0 0 0-.061 1.047zm24.685-9.825l5.895 8.474h-11.79zm14.246-.061l7.921 8.6h-13.2zm-1.658-.553l-5.162 8.41-5.83-8.413zm-14.185 0l-5.834 8.413-5.158-8.413z",
  className: "celebrities-cls-2",
  "data-name": "Path 228",
  transform: "translate(-9.511 -20.6)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_229",
  d: "M17.045 46.6a.226.226 0 0 0-.184.061c-.061 0-.123 0-.123.061l-.123.123a.759.759 0 0 0-.246.86.866.866 0 0 0 .675.614.46.46 0 0 0 .307-.061c.123 0 .184-.061.307-.123a.8.8 0 0 0 .123-1.167.733.733 0 0 0-.553-.307l-.184-.061z",
  className: "celebrities-cls-3",
  "data-name": "Path 229",
  transform: "translate(-12.14 -30.634)"
});

var SvgCelebrities = function SvgCelebrities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Celebrities",
    width: 49.67,
    height: 42.309,
    viewBox: "0 0 49.67 42.309",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCelebrities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Celebrities.d7afd988.svg";
export { ForwardRef as ReactComponent };